<!-- Client Admin View -->
<div v-if="user_role === 'ClientAdmin'" class="container py-4">
  <div class="row">
    <!-- QR Code Display -->
    <div v-if="qr_code_data && qr_code_data.link && qr_code_data.qr_code" class="col-lg-12 ms-0 mb-4">
      <div class="card h-80 rounded-3 border-1 shadow-sm p-2">
        <div class="card-body row g-0 align-items-start">
          <div class="col-auto">
            <img class="mb-3 qr-code-image" alt="QR" :src="qr_code_data.qr_code" width="180px" />
          </div>
          <div>
            <button 
              @click="download_qr_code" 
              v-if="qr_code_data.id"
              type="button" 
              class="btn bg-green text-xs fw-bold rounded-small shadow"
            >
              download QR code
            </button>
          </div>
          <div class="col mt-3">
            <div>
              <label><strong>Asset Name </strong></label>
              <span class="mb-2"> : {{ asset_data.asset_name }}</span>
            </div>
            <div>
              <label><strong>Assigned WorkFlow </strong></label>
              <span class="mb-3"> : {{ workflow_data.workflow_name }}</span>
            </div>
            <div>
              <label><strong>Link </strong></label>
              <a :href="qr_code_data.link" target="_blank" rel="noopener noreferrer">
                : {{ qr_code_data.link }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Asset Information Form -->
    <div class="col-lg-12 ms-0">
      <div class="card h-100 rounded-3 border-1 shadow-sm">
        <div class="card-body p-3 mb-5">
          <p class="text-uppercase text-xs text-blue fw-bold mt-4">Asset Information</p>
          <div class="underline rounded-small mt-1"></div>

          <!-- Begin Form -->
          <form @submit.prevent="edit_asset" class="position-relative">
         
            <div class="col-md-6">
              <!-- Asset Name -->
              <div class="mb-3">
                <label for="asset-name" class="form-label fw-bold text-xs">Name</label>
                <input
                  id="asset-name"
                  type="text"
                  class="form-control form-control-lg"
                  placeholder="Enter asset name"
                  v-model="asset_details.asset_name"
                >
              </div>

              <!-- Description -->
              <div class="mb-3">
                <label for="asset-description" class="form-label fw-bold text-xs">Description</label>
                <input
                  id="asset-description"
                  type="text"
                  class="form-control form-control-lg"
                  placeholder="Enter description"
                  v-model="asset_details.asset_description"
                >
              </div>

              <!-- Asset Type -->
              <div class="mb-3">
                <label for="asset-type" class="form-label fw-bold text-xs">Asset Type</label>
                <input
                  id="asset-type"
                  disabled
                  type="text"
                  class="form-control form-control-lg"
                  placeholder="Enter asset type"
                  v-model="asset_details.asset_type"
                >
              </div>
              <div class="card-img-top">
                <div>
                <img v-if="imageUrl" :src="imageUrl" alt="Preview" class="img-fluid rounded" />
                <img v-else-if="asset_details.uploaded_image" :src="asset_details.uploaded_image" alt="Current image" class="img-fluid" />
                <div v-else class="placeholder">No image selected</div>
  
              </div>
              </div>
            </div>

        
        
            <div class="d-flex justify-content-between mt-4">
              
              <div>
                <button
                  type="button"
                  class="btn bg-green text-xs fw-bold rounded-small shadow"
                  @click="triggerFileUpload"
                >
                <i class="fa fa-upload "></i> Upload
                </button>
                <input
                  id="file-upload"
                  type="file"
                  accept="image/*"
                  @change="handle_file_upload"
                  ref="fileInput"
                  class="d-none text-xs upload-input"
                >
              </div>
            
              
              <div>
                <button 
                  type="submit" 
                  class="btn bg-green text-xs fw-bold rounded-small shadow"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal View for Client / System Admin -->
<div v-else class="modal fade show d-block" tabindex="-1" role="dialog" style="background-color: rgba(0,0,0,0.5)">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content border-0 shadow-lg rounded-3">
      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title fw-bold text-s">Asset Information</h5>
        <button type="button" class="btn-close" @click="$router.go(-1)" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="decorative-card rounded-small bg-light">
              <div class="p-3">
                <div class="row align-items-start">                                 
                  <div v-if="imageUrl" class="col-md-3 mb-3">
                    <img 
                      :src="imageUrl" 
                      class="img-fluid rounded shadow-sm"
                      :alt="asset_details.asset_name"
                      style="max-height: 250px; object-fit: cover;"
                    />
                  </div>
          
                  <div :class="imageUrl ? 'col-md-6' : 'col-md-8'">
                    <div class="d-flex align-items-start justify-content-between mb-2">
                      <div class="w-100">
                        <p class="mb-0 text-s fw-bold">
                          Asset: {{ asset_details.asset_name }}
                        </p>
                        <div v-if="asset_details.asset_description" class="mb-2">
                          <span class="text-xs fw-bold">Description:</span>
                          <p class="text-xs text-muted mb-0">{{ asset_details.asset_description }}</p>
                        </div>
                      </div>
                    </div>
                    
                    
                    <div v-if="asset_details.date_created" class="text-xs mb-1">
                      <span class="fw-bold">Created:</span>
                      <span class="ms-2 text-muted">{{ formatDate(asset_details.date_created) }}</span>
                    </div>

                    <div v-if="workflow_data.workflow_name" class="text-xs mb-1">
                      <span class="fw-bold">Workflow:</span>
                      <span class="ms-2 text-muted">{{ workflow_data.workflow_name }}</span>
                    </div>
                    
                    <div class="text-xs mb-1">
                      <span class="fw-bold">Status:</span>
                      <span class="ms-2">
                        <span v-if="asset_details.is_active" class="badge bg-success text-white text-xxs">Active</span>
                        <span v-else class="badge bg-secondary text-white text-xxs">Inactive</span>
                      </span>
                    </div>

                    <div v-if="qr_code_data.link" class="text-xs mb-1">
                      <span class="fw-bold">Link:</span>
                      <a 
                        :href="qr_code_data.link" 
                        target="_blank" 
                        class="ms-2 text-primary text-decoration-none"
                        rel="noopener noreferrer"
                      >
                        <i class="fas fa-external-link-alt me-1"></i>
                        View
                      </a>
                    </div>
                  </div>
                  
                  <!-- QR Code Section -->
                  <div class="col-md-3 text-center">
                    <p class="text-xs fw-bold mb-3">Asset QR Code</p>
                    
                    <!-- QR Code Container -->
                    <div class="qr-code-wrapper mb-3">
                      <div v-if="qr_code_data.qr_code" class="qr-code-container bg-white p-3 rounded shadow-sm d-inline-block">
                        <img 
                          :src="qr_code_data.qr_code" 
                          class="img-fluid"
                          alt="QR Code"
                          style="width: 150px; height: 150px;"
                        />
                      </div>
                      <div v-else class="qr-code-placeholder bg-white rounded shadow-sm d-inline-flex align-items-center justify-content-center">
                        <i class="fas fa-qrcode fa-3x text-muted"></i>
                      </div>
                    </div>
                    
                    <!-- Download Button -->
                    <button 
                      v-if="qr_code_data.qr_code && qr_code_data.id"
                      @click="download_qr_code" 
                      class="btn bg-green text-white text-xxs fw-bold rounded-small shadow-sm px-3 py-2"
                    >
                      <i class="fas fa-download me-1"></i> Download QR
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>